module.exports = __webpack_public_path__ + "static/logo_zielone_pogotowie-1deeabc9afdb3744d68158e85f2f32d6.svg";